import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { CalendarClock } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ownerApi, apiError, fmtDate, daysLeft } from './ownerApi';

export const LicenseCard = ({ license, onSaved }) => {
  const [start, setStart] = useState(license.start_date || '');
  const [end, setEnd] = useState(license.end_date || '');
  useEffect(() => { setStart(license.start_date || ''); setEnd(license.end_date || ''); }, [license]);
  const left = daysLeft(license.end_date, license.today);

  const run = async (fn, msg) => {
    try { onSaved((await fn()).data); toast.success(msg); } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="owner-license-card">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-orange-50 text-orange-500"><CalendarClock className="h-5 w-5" /></span>
          <div><h2 className="text-lg font-semibold text-slate-900">Lisans Yönetimi</h2>
            <p className="text-sm text-slate-500">Süre dolunca tüm kullanıcıların erişimi otomatik kapanır.</p></div>
        </div>
        <span className={`rounded-full px-3 py-1 text-xs font-semibold ${license.active ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-700'}`} data-testid="owner-license-status">
          {license.active ? `Aktif · ${left} gün kaldı` : 'Süresi doldu'}
        </span>
      </div>
      <p className="mt-5 text-sm text-slate-600">Geçerlilik: <b data-testid="owner-license-range">{fmtDate(license.start_date)} – {fmtDate(license.end_date)}</b></p>
      <div className="mt-4 grid gap-4 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
        <div className="space-y-1.5"><Label>Başlangıç</Label><Input type="date" value={start} onChange={e => setStart(e.target.value)} data-testid="owner-license-start" /></div>
        <div className="space-y-1.5"><Label>Bitiş</Label><Input type="date" value={end} onChange={e => setEnd(e.target.value)} data-testid="owner-license-end" /></div>
        <Button onClick={() => run(() => ownerApi.put('/platform-owner/license', { start_date: start, end_date: end }), 'Lisans tarihleri kaydedildi')} data-testid="owner-license-save">Kaydet</Button>
      </div>
      <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-slate-100 pt-5">
        <span className="mr-1 text-sm font-medium text-slate-700">Uzat:</span>
        {[1, 3, 6, 12].map(m => (
          <Button key={m} variant="outline" size="sm" onClick={() => run(() => ownerApi.post('/platform-owner/license/extend', { months: m }), `Lisans ${m} ay uzatıldı`)} data-testid={`owner-license-extend-${m}`}>
            +{m === 12 ? '1 yıl' : `${m} ay`}
          </Button>
        ))}
      </div>
    </section>
  );
};
